__turbopack_context__.v({
  "className": "K20EHq_className",
  "variable": "K20EHq_variable",
});
